<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Oa6ML2/tc-custom/9781526758569.jpg?1705010292762" alt="This image is the cover for the book United States Navy Destroyers, Images of War"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">United States Navy Destroyers, Images of War
      </h1>
      <p class="bookDescription body article font2">
        <b>This pictorial history examines the key role played by US Navy destroyers from the turn of the twentieth century through the Cold War and beyond.</b><br/><br/>The first sixteen United States Navy destroyers were ordered in 1898. Prior to America’s entry into the First World War, another sixty-three destroyers were commissioned and, due to the U-boat threat, 267 more were authorized by Congress once hostilities were joined.<br/><br/>Between 1932 and Pearl Harbor ten new classes totaling 169 destroyers came into service. During the Second World War, American shipyards turned out a further 334 vessels. Of the three classes, the 175 Fletcher-class were judged the most successful.<br/><br/>The Cold War years saw the development of seven more classes, while more recent additions include eighty-two of the stealth-shaped Arleigh Burke class. In this comprehensive account, author and military expert Michael Green combines a superb collection of historical images with an authoritative text.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Michael Green
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Pen and Sword Maritime
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?b96e7de4